module.exports = __webpack_public_path__ + "static/media/Path@1.5x.5fe55b97.svg";